import { stripe_payment } from "../stripe/stripe.js";
import { totalParticipantes, getParticipantes } from './participantes.js';
import { getHoraSeleccionada } from './hora_seleccionada.js';
import { alertas } from '../ui/ui.js';


export async function guardarReserva() {

    var nombre = document.getElementById('nombre').value;
    var email = document.getElementById('email_contacto').value;
    var telefono = document.getElementById('telefono').value;
    var fecha = document.getElementById('fecha').value;


    const actividadSeleccionada = document.querySelector('input[name="actividad"]:checked');

    if (!actividadSeleccionada) {
        alert("Debe seleccionar un lugar de la actividad.");
        return;
    }

    const lugar_actividad = actividadSeleccionada.value;



    // Número de participantes

    // Validaciones
    if (totalParticipantes() < 1) {
        alert("Debe agregar al menos un participante.");
        return;
    }

    const actividadSel = document.querySelector('input[name="actividad"]:checked')?.value;
    const n = totalParticipantes();

    if (actividadSel === "Alberca") {
        // Piscina: obligatorio exactamente 2 participantes
        if (n !== 2) {
            alert("Para la Piscina Climatizada es obligatorio exactamente 2 participantes por reserva.");
            return;
        }
    } else {
        if (n > 3) {
            alert("El máximo permitido son 3 participantes.");
            return;
        }
    }

    // Precio según lugar y nº de participantes
    let precioPersona = 0;
    let subtotal = 0;

    if (lugar_actividad === "Alberca") {
        // 49 € por persona, obligatorio 2 participantes → total 98 €
        precioPersona = 49;
        subtotal = 49 * n;
    } else {
        switch (n) {
            case 1:
                precioPersona = 50;
                break;
            case 2:
                precioPersona = 35;
                break;
            case 3:
                precioPersona = 30;
                break;
            default:
                precioPersona = 50;
        }
        subtotal = precioPersona * n;
    }

    // Gastos de viaje
    let gastosViaje = 0;

    if (lugar_actividad === "La Herradura Almuñecar") {
        gastosViaje = 30;
    }

    // Total
    let total = subtotal + gastosViaje;

    console.log({
        participantes: totalParticipantes(),
        precioPersona,
        subtotal,
        gastosViaje,
        total
    });


    const deposito_por_persona = Number((precioPersona / 2).toFixed(2));
    const total_depositos = Number((deposito_por_persona * totalParticipantes()).toFixed(2));

    const reservaData = {
        key_reserva: crypto.randomUUID(),
        fecha: fecha,
        hora: getHoraSeleccionada(),
        tipo_servicio: lugar_actividad,
        nombre: nombre,
        email: email,
        telefono: telefono,
        participantes: getParticipantes(),
        numero_participantes: totalParticipantes(),
        precio_persona: precioPersona,
        deposito_persona: deposito_por_persona,
        subtotal: subtotal,
        gastos_viaje: gastosViaje,
        total_depositos: total_depositos,
        total: total,
        fecha_creacion: new Date().toISOString().slice(0,19).replace('T',' ')
    };


console.log(reservaData.key_reserva)

//stripe_payment(email, nombre, total);


    try {

        const response = await fetch('https://my-first-dive.com/Index/guardar_reserva', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(reservaData)
        });

        const result = await response.json();

        if (result.success) {


            console.log(JSON.stringify(result))

            // Enviar el importe a Stripe
            //stripe_payment(email, nombre, total_depositos, result.key_reserva);

            alertas(
                { 
                type: "success", 
                title: "Espere unos momentos", 
                message: "Estamos redireccionando a su reserva", 
                autoClose: 3000, 
                redirect: "https://my-first-dive.com/Index/Detalles_Reserva/?key_reserva=" + result.key_reserva 
                 }
                );


        } else {
            alert(result.message || "Error al guardar.");
        }

    } catch(e) {
        console.error(e);
        alert(e.message);
    }
    
}